import { Field } from ".";

import {
  FieldDefinitionFieldType,
  FieldDefinitionRouterType,
  FieldImperativeHandle,
} from "@/components/@types";

function FieldRouterValue<T extends FieldDefinitionRouterType<T>>({
  data,
  value,
  events,
  isMultiline,
  size,
  store,
  style,
  ref,
}: { data: unknown } & FieldDefinitionFieldType<
  FieldDefinitionRouterType<T>
> & {
    ref?: React.Ref<FieldImperativeHandle>;
  }) {
  const { type, getValue, getValueOptions } = value;

  return (
    <Field
      data={data}
      events={events}
      type={type}
      getValue={getValue}
      getValueOptions={getValueOptions}
      isMultiline={isMultiline}
      size={size}
      store={store}
      style={style as React.CSSProperties}
      ref={ref}
    />
  );
}

export function FieldRouter<T extends FieldDefinitionRouterType<T>>({
  isLoading,
  ref,
  ...props
}: { data: unknown } & FieldDefinitionFieldType<
  FieldDefinitionRouterType<T>
> & {
    ref?: React.Ref<FieldImperativeHandle>;
  }) {
  return <FieldRouterValue {...props} ref={ref} />;
}
